'use client'

import WorldInfoDetails from '@/app/[locale]/(worlds)/[roomId]/components/WorldInfoDetails'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useUAContext } from '@/context/UAContext'
import { cn } from '@/lib/utils'

function WorldInfoDetailsSection() {
  const { isMobileLandscape } = useUAContext()
  const { isOwnerViversePro } = useCheckEnterRoomContext()

  if (isMobileLandscape) return null

  return (
    <div
      data-section="world-info-details"
      className={cn('flex w-full flex-col max-md:px-4', {
        '3xl:max-w-[1440px] lg:max-w-[75vw]': !isOwnerViversePro,
      })}
    >
      <WorldInfoDetails />
    </div>
  )
}

export default WorldInfoDetailsSection
